module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAD+SURBVEhL3ZPRCcJAEETzp9ahfWgVWoaCfgmipVqCBQi6ozc4rNm7DSKID4Ykm9uZc+N1f8+xqMXedDGtHk9JYHwrqoXouqspFcImNEC1kJOJAexZmkLUHLuBGLI1kXm5Ah+CcfXizQnuz6bZ4+m1Tn+VhhxQ8ETmZFSuXEf5EKgX7iAKAN6c0pAqtZDInFqYUjAEMx+jYLTMw7FEbEz+g0YabK5kzbGZ9fM2T9Z8YsI4UUNPiqFjwR+Ch7EZMtScpEKy5jx0igZEm3gzVLFpasLM9ZykzIE3pbRpZ0KNhzFtDtSU6mtCDe9gnDYHatxqYkhr3UfA+Gvmv0DX3QHiF7K32PubWwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-design/dark/24.png
// module id = 1982
// module chunks = 2